{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "identity",
  "x-cli-editable": true,
  "title": "Identity",
  "description": "Brand and company information: name, logo, language.",
  "type": "object",
  "properties": {
    "description": {
      "type": "string",
      "ui:widget": "textarea",
      "ui:description": "Company description for LLM context",
      "maxLength": 2000
    },
    "company_name": {
      "type": "string",
      "ui:description": "Company name for display",
      "maxLength": 200,
      "minLength": 1
    },
    "website_url": {
      "type": "string",
      "format": "uri",
      "ui:description": "Main website URL",
      "pattern": "^$|\\.[a-zA-Z]{2,}"
    },
    "logo_url": {
      "type": [
        "string",
        "null"
      ],
      "format": "uri",
      "ui:description": "Logo URL",
      "pattern": "\\.[a-zA-Z]{2,}"
    },
    "display_name": {
      "type": "string",
      "ui:description": "Display name (if different from company_name)",
      "maxLength": 200
    },
    "default_language": {
      "type": "string",
      "enum": [
        "en",
        "fr",
        "es",
        "de",
        "it",
        "pt",
        "bg",
        "nl",
        "ro",
        "hu"
      ],
      "ui:tooltip": "Site language",
      "ui:description": "Buttons, CTAs, and welcome messages always appear in this language."
    },
    "llm_response_language": {
      "type": "string",
      "enum": [
        "website_language",
        "auto"
      ],
      "ui:tooltip": "AI response language",
      "ui:description": "Website language: AI responds in the site language above (recommended). Auto: AI detects the visitor's language from their message — less reliable, may produce mixed-language answers."
    },
    "additional_languages": {
      "type": "array",
      "uniqueItems": true,
      "items": {
        "type": "string",
        "enum": [
          "en",
          "fr",
          "es",
          "de",
          "it",
          "pt",
          "bg",
          "nl",
          "ro",
          "hu"
        ]
      },
      "ui:title": "Additional languages",
      "ui:description": "Other languages your site serves besides the primary language. Rose shows buttons, CTAs, and starter questions in each of these too — for example, you set a CTA link per language."
    }
  },
  "required": [
    "company_name"
  ],
  "default": {
    "description": "",
    "company_name": "",
    "website_url": "",
    "logo_url": null,
    "display_name": "",
    "default_language": "fr",
    "llm_response_language": "website_language",
    "additional_languages": []
  }
}
